import { motion } from 'motion/react';

const OverlayFadeMotion = ({
  keyProp,
  className = '',
  duration = 0.2,
  disabled = false,
  ...rest
}) => (
  <motion.div
    key={keyProp}
    initial={disabled ? false : { opacity: 0 }}
    animate={disabled ? false : { opacity: 1 }}
    exit={disabled ? false : { opacity: 0 }}
    transition={{ duration }}
    className={className}
    {...rest}
  />
);

export default OverlayFadeMotion;
